module.exports = __webpack_public_path__ + "static/media/IMG_8909.cf8f1ae3.JPG";